/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */
import TriFloorPlanPlugin from "./TriFloorPlanPlugin.js";
import TriFloorPlanUtils from "../util/TriFloorPlanUtils.js";

export default class TriHighlightPlugin extends TriFloorPlanPlugin {
  static type = "highlight";

  pluginDidUpdate() {
    const {
      floorPlanLoaded,
      enabled,
      className,
      useInteractiveLayer,
      highlighted,
    } = this.props;
    if (!floorPlanLoaded || !enabled) {
      this.clearAllAttachedClasses();
      return;
    }
    if (
      className !== this.lastClassName ||
      useInteractiveLayer !== this.lastUseInteractiveLayer ||
      highlighted !== this.lastHighlighted
    ) {
      this.lastClassName = className;
      this.lastUseInteractiveLayer = useInteractiveLayer;
      this.lastHighlighted = highlighted;
      this.updateHighlight();
    }
  }

  pluginDidRemove() {
    this.clearAllAttachedClasses();
  }

  clearAllAttachedClasses() {
    const { floorPlanLoaded, triFloorPlan, className } = this.props;
    if (!floorPlanLoaded) return;
    const { svgElement } = triFloorPlan;
    TriFloorPlanUtils.clearAllClasses(className, svgElement);
  }

  updateHighlight() {
    const { highlighted } = this.props;
    this.clearAllAttachedClasses();
    if (!highlighted) return;

    if (Array.isArray(highlighted)) {
      highlighted.forEach((highlight) => {
        this.addHighlightClass(
          TriFloorPlanUtils.getPropValue(highlight, TriHighlightPlugin.SPACE_ID)
        );
      });
    } else {
      this.addHighlightClass(
        TriFloorPlanUtils.getPropValue(highlighted, TriHighlightPlugin.SPACE_ID)
      );
    }
  }

  addHighlightClass(id) {
    const { className, useInteractiveLayer, triFloorPlan } = this.props;
    const map = useInteractiveLayer
      ? triFloorPlan.interactiveMap
      : triFloorPlan.attachedMap;
    TriFloorPlanUtils.addClass(id, className, map);
  }
}
